import React from "react";
import { X } from "lucide-react";

export default function RemoveBtn({ setValue, inputRef }) {
  return (
    <div>
      <button
        className={`absolute right-5 top-4 rounded-button-effect custom-shadow-effect rounded-full border bg-white hover:bg-gray-100`}
        onClick={(e) => {
          e.preventDefault();
          setValue("");
          inputRef.current?.focus();
        }}
        type="button"
      >
        <X size={17} />
      </button>
    </div>
  );
}
